<template>
    <v-card min-width="25vw" align="center" justify="center" outlined>
        <v-card-title>
            <v-list-item>
                <v-list-item-title><h2>Cancel your Pro Subscription</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-5 pt-5">
            <v-form v-model="valid">
                <v-container fluid>
                  <v-form v-model="valid">
                    <v-textarea label="Unsubscribe reason" placeholder="Unsubscribe reason"
                                hint="Why did you decide to cancel your pro subscription." v-model="reason"
                                :rules="reasonRules"
                                counter="120" rows="1" auto-grow outlined/>
                    <div class="mb-3 mt-2">
                      <v-btn @click="closeWindow">Cancel</v-btn>
                      <v-btn class="ml-5" :disabled="!valid" @click="cancelSubscription">Unsubscribe</v-btn>
                    </div>
                  </v-form>
                </v-container>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
import SubscriptionRepository from '../../../repositories/subscription';

export default {
    name: "CancelSubscription",
    data() {
        return {
            valid: false,
            reason: '',
            reasonRules: [
              r => !!r || 'Reason is required',
              r => (r && r.length <= 120) || 'Max 120 characters',
            ],
        }
    },
    methods: {
        cancelSubscription(){
            // Make validations of form
            SubscriptionRepository.cancelSubscription(this.$store.state.user.id, this.reason).then((response) => {
                if (response.status < 400) {
                    window.console.log("Success");
                    // Show success message with response.data
                }else{
                    window.console.log("Error");
                    // Show error message with response.data
                }
            });
        },
        closeWindow() {
            this.$emit('closeWindow');
        },
    }
}
</script>

<style>

</style>
